import { Button, ButtonStyle, ClientDashboard, clearSWRCache, CSVReader, Form, FormStyle, Formik, 
         FormikControl, FieldArray, handelFileChange, InputError, onAdminUserAdd, onAdminUserRemove, React, 
         setAddUserInitialValues, SidebarAction, useQueryClient, useRef, useRouter, useState, useSWR, useTranslation, 
         VALIDATION_SCHEMA, useEffect, motion, PAGE_ANIMATION_OPTIONS, ErrorPages, CloseIcon, getMyTeam, addTeamMembers, 
         SkipModal, PageStyle} from "@/imports-files/pages/admins/dashboard/clients/add-users";
   
         
function AddTeamMember(props)
{
    clearSWRCache('client_add_team');
    const router                              =   useRouter();
    const errorPages                          =    new ErrorPages();
    const [ apiError, setApiError]            =   useState()
    const { t, i18n }                         =   useTranslation();
    const formRef                             =   useRef(null);
    const [total_admin, setAdminCount]        =   useState(0);
    const step                                =   router.query.step;
    const isQuickSetup                        =   router.query.step && router.query.step == 'add_teams' ? true : false
    const [skipModal, setSkipModal]           =   useState(false);
    const [initialValues, setInitialValues]   =   useState(Object.assign({}, setAddUserInitialValues()));
    const [userRoles, setUserRoles]           =   useState({} )
    const [ isLoading, setLoading]            =   useState(true);
    const queryClient                         =   useQueryClient();
    const CSV_OPTIONS                         =   {
                                                    header: true,
                                                    dynamicTyping: true,
                                                    skipEmptyLines: true,
                                                    transformHeader: header => header.toLowerCase().replace(/\W/g, '_')
                                                  };   
    const {data, error}                       =   useSWR('client_add_team', () => { return (getMyTeam(router, setApiError))}, { revalidateOnFocus: false } );


     useEffect(() => {
                        if(data)
                        {
                          var store_data = queryClient.getQueryData('add-user-data');
                        
                          if(store_data != undefined && data.client !=undefined)
                          {
                            data.client.client_users_attributes =  store_data;
                          }
                          data.client.client_users_attributes.length ? setInitialValues({client: data.client}) : ''; 
                          setAdminCount(store_data?.filter((element) => element._destroy==false).length || data.client.client_users_attributes.length);
                          setUserRoles(data.user_roles)
                          setLoading(false)

                          if(isQuickSetup)
                           setTimeout(() =>  {
                                              new SidebarAction().subsidebarQuickSetupChangeIcon( data.sidebar_options.complete_steps, 'add_teams');
                                            }, 750);
                        }
                    }, [data])


    if(isLoading || error || errorPages.handleErrorCodes(apiError?.status))
    {
      var renderPage  =  (error || apiError) ? errorPages.renderPage(error?.status || apiError?.status, router) : null;
      return renderPage; 
    } 
    if(process.env.NEXT_PUBLIC_CHARLIE_HR) { return (<></>) }
    return(
            <div className={`Page DashboardPageContent`}>
              <motion.div initial="pageInitial"  animate="pageAnimate"  exit="pageExit"  variants={PAGE_ANIMATION_OPTIONS}  transition={{ delay: 0.2}}>
                 {
                  <>

                        <div className={PageStyle.AddUsers__Container}>
                            {!isQuickSetup && <h1 className={PageStyle.AddUsers__Heading}>
                            Add Team Member
                            </h1>}

                            {isQuickSetup && <h1 className={PageStyle.AddUsers__Heading}>
                            Welcome  <span className={PageStyle.ClientCompany__Company}>{data?.client?.name}</span><br/>
                            Let’s get started.
                            </h1>}
                            {isQuickSetup && <h3 className={PageStyle.AddUsers__QuickStepHeading}>Team</h3>}
                            <h4 className={PageStyle.AddUsers__Subheading}>
                              Individuals that’ll be using Charlie Recruit. For speed, you can <a href={'/sample_users.csv'} download="sample_users.csv">download CSV template</a> and import a list of users.
                              You can also add more later.
                            </h4>

                            <div className={PageStyle.AddUsers__ButtonsActionSection}>

                              <div>
                                <Button buttonstyle={ButtonStyle.primarybtn}
                                        type='button'
                                        onClick = {() => onAdminUserAdd(formRef, "add", setAdminCount, queryClient)}
                                >
                                 Add User
                                </Button>
                              </div>

                              <div className={PageStyle.AddUsers__ImportUsers}>

                                  <CSVReader
                                      cssClass="react-csv-input"
                                      parserOptions={CSV_OPTIONS}
                                      onFileLoaded={(user_data, fileInfo) => handelFileChange(user_data, formRef, setAdminCount, userRoles, queryClient, fileInfo)}
                                  />

                                  <Button buttonstyle={ButtonStyle.tertiarybtn}>
                                    Bulk Import User
                                  </Button>

                              </div>

                         </div>
                         <div className={PageStyle.FormSection}>


                        <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={VALIDATION_SCHEMA}
        onSubmit={ async(values, actions) => {
          const errors = await addTeamMembers(values,router, isQuickSetup);
          actions.setErrors(errors)
        }
      }
      innerRef={formRef}

>
{(formik) => (
    <Form>
      <FieldArray name="client_users_attributes">
        {
          () => (formik.values.client.client_users_attributes.map((client, index) => {
            return (!client['_destroy'] && <div key={index} className = {`mt15 ${PageStyle.AddUsers__FormSection}`}>
                      
                          <div>
                          <label className={`mb20 ${FormStyle.Form__Label}`}>{t('common:texts:role')} *</label>
                            <FormikControl className    =  {`${PageStyle.Form__Input} ${PageStyle.AddUsers__RoleInput}`}
                                          control      =  "select"
                                          errorClass   =  {PageStyle.Form__Error}
                                          formik       =  {formik}
                                          name         =  {`client.client_users_attributes.${index}.role_id`}
                                          onChange     =  {(option) => formik.setFieldValue(`client.client_users_attributes.${index}.role_id`, option.value)}
                                          options      =  {userRoles}
                                          style        =  {InputError(formik, `client.client_users_attributes.${index}.role_id`)}
                                          default      =  {client.role_id !='' ? client.role_id: ''}
                                          />
                          </div>

                          <div>
                          <label className={`mb20 ${FormStyle.Form__Label}`}>{t('common:texts:name')} *</label>
                            <FormikControl control     =   "input"
                                          type         =   "text"
                                          formik       =  {formik}
                                          name         =   {`client.client_users_attributes.${index}.user_attributes.name`}
                                          placeholder  =   {t('common:texts:example_name')}
                                          className    =   {` ${PageStyle.Form__Input} ${PageStyle.AddUsers__NameInput}`}
                                          errorClass   =   {PageStyle.Form__Error}
                                          style        =   {InputError(formik, `client.client_users_attributes.${index}.user_attributes.name`)}
                                          />

                          </div>

                          <div>
                          <label className={`mb20 ${FormStyle.Form__Label}`}>{t('common:texts:email')} *</label>
                            <FormikControl control     =  "input"
                                          type         =  "text"
                                          formik       =  {formik}
                                          name         =  {`client.client_users_attributes.${index}.user_attributes.email`}
                                          placeholder  =  {t('common:texts:example_email')}
                                          autoComplete =  "password" 
                                          className    =  {`${PageStyle.Form__Input} ${PageStyle.AddUsers__EmailInput}`}
                                          errorClass   =  {PageStyle.Form__Error}
                                          style        =  {InputError(formik, `client.client_users_attributes.${index}.user_attributes.email`)}
                                          />
                          </div>


                          <div className = {PageStyle.AddUsers__DeleteCrossHeight}>
                            {client.deletable && <Button color       = "primary"
                                    buttonstyle = {ButtonStyle.nobgbutton}
                                    onClick  = {() => onAdminUserRemove( formik, "remove", setAdminCount, index, queryClient )}>
                                <CloseIcon/>
                            </Button>}
                                              
                          </div>

                    </div>);
          }))
        }
      </FieldArray>

      {skipModal && <SkipModal setBtnPopup={setSkipModal} router={router}></SkipModal>}
      <div className={`space`}></div>
      <div className={PageStyle.AddUsers__SubmitSection}>
        <Button buttonstyle={PageStyle.secondarybtnborder} type="button" onClick={() => {
                          setSkipModal(true)}}> Skip </Button>
        <Button type="submit" buttonstyle={ButtonStyle.primarybtn}>
          {t('common:texts:next_step')}
        </Button>
      </div>

    </Form>)}
</Formik>

</div>
                    </div>
</>
                }
              </motion.div>
            </div>)
}


AddTeamMember.layout = ClientDashboard;
export default AddTeamMember;